import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { HeaderWithNextButton, NextButton } from "@components";

export const HeaderWithNextButtonLayout = ({
  title,
  subtitle,
  action,
  isDisabled,
  children,
}: {
  title: string;
  subtitle?: string;
  action: () => void;
  isDisabled?: boolean;
  children: ReactNode;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="py-10">
        <HeaderWithNextButton
          title={t(title)}
          subtitle={subtitle ? t(subtitle) : undefined}
          action={action}
        />
      </div>
      {children}
      <div className="text-end border-top py-8 mt-10">
        <NextButton action={action} disabled={isDisabled} />
      </div>
    </>
  );
};
